import { Notification } from 'element-ui'

export default ({}, inject) => {
  inject('notify', Notification)
}
